import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  UpdateJustificationReverseLogisticsActions as Actions,
  UpdateJustificationReverseLogisticsRequestAction as RequestAction,
} from 'store/ducks/justificationsReverseLogistics';

export function* updateJustificationReverseLogisticsRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(putData);
    yield call(api.put, `reverse-logistics/configurations/justifications/${id}`, formData);
    onSuccess && onSuccess();
    notify('success', 'Justificativa atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
